import React, { useContext, useState } from 'react'
import { AppContext } from '../context/AppContext'
import axios from 'axios'
import { useHistory } from 'react-router'
import StripeModal from './StripeModal'
import styled from 'styled-components'

export default function CourseButton({ unit, lesson }) {
  const { appState, appDispatch } = useContext(AppContext)
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()

  const displayButton = () => {
    if(appState.isUserLoggedIn) {
      if(appState.isCoursePurchased) {
        // User has access - get started
        return (
          <CourseButtonStyle className={`featured-lesson-button button`} onClick={goToLesson}>
            {isLoading && <div className="tt-loader"></div>}
            {appState.latestLesson ? 'Continue' : 'Get Started'}
          </CourseButtonStyle>
        )
      } else if (appState.isCourseFree) {
        // Enroll and proceed - enroll
        return (
          <CourseButtonStyle className={`enroll-course-button button`} onClick={enrollInCourse}>
            {isLoading && <div className="tt-loader"></div>}
            Enroll
          </CourseButtonStyle>
        )
      } else {
        // User must purchase - purchase
        if(appState.stripeKey) {
        return (
          <CourseButtonStyle className={`purchase-course-button button no-smoothState`} onClick={purchaseCourse}>
            {isLoading && <div className="tt-loader"></div>}
            {`Purchase - $${appState.course.price}`}
          </CourseButtonStyle>
        ) 
        } else {
          return (
            <ErrorText className="stripe-error">
              Please contact us to purchase course.
            </ErrorText>
          )
        }
      }
    } else {
      if(appState.isCourseFree) {
        // Login for access
        return (
          <CourseButtonStyle className={`react-login-button button no-smoothState`}>
            {isLoading && <div className="tt-loader"></div>}
            Login or Register for Access
          </CourseButtonStyle>
        )
      } else {
        return (
          <CourseButtonStyle className={`react-login-button button no-smoothState`}>
            {isLoading && <div className="tt-loader"></div>}
            Login or Register to Purchase
          </CourseButtonStyle>
        )
      }
    }
  }

  const goToLesson = (e) => {
    e.preventDefault()
    // Trigger status update for lesson
    const postData = new FormData()
    postData.append('courseId', appState.course.id)
    postData.append('lessonKey', lesson.slug)
    postData.append('unitKey', unit.key)
    postData.append('status', 'STARTED')
    setIsLoading(true)
    axios.post(appState.envVars.COURSE_PROGRESS_API, postData,
      {
        headers: {
        'X-WP-Nonce': window.ttnonce || window.TTI_REST_NONCE
      }})
      .then(res => {
        console.log("Progress res", res)
        if(res) {
          appDispatch({
            type: 'setLatestLesson',
            lesson: {
              lesson,
              unit
            }
          })
          appDispatch({
            type: 'setLessonStatus',
            lessonKey: lesson.slug,
            unitKey: unit.key,
            status: 'STARTED'
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setIsLoading(false)
        history.push(`/courses/${appState.course.slug}/${unit.key}/${lesson.slug}`)
      })
  }
  
  const enrollInCourse = (e) => {
    e.preventDefault()
    // Enroll from endpoint
    const postData = new FormData()
    postData.append('courseId', appState.course.id)
    setIsLoading(true)
    axios.post(appState.envVars.COURSE_ENROLL_API, postData,
      {
        headers: {
        'X-WP-Nonce': window.ttnonce || window.TTI_REST_NONCE
      }})
      .then(({data}) => {
        if(data.course.ID === appState.course.id) {
          appDispatch({type: 'setCoursePurchased', isCoursePurchased: true})
          const now = new Date()
          const mHours = now.getHours()
          let hours = mHours
          let tod = "am"
          if(mHours === "0") {
            hours = "12"
          } else if(mHours > "12") {
            hours = mHours - 12
            tod = "pm"
          }
          const time = hours + ':' + now.getMinutes() + ':' + now.getSeconds() + ' ' + tod
          appDispatch({type: 'purchaseCourse', time: time})
          // Trigger status update for lesson
          const progressPostData = new FormData()
          progressPostData.append('courseId', appState.course.id)
          progressPostData.append('lessonKey', lesson.slug)
          progressPostData.append('unitKey', unit.key)
          progressPostData.append('status', 'STARTED')
          axios.post(appState.envVars.COURSE_PROGRESS_API, progressPostData,
            {
              headers: {
              'X-WP-Nonce': window.ttnonce || window.TTI_REST_NONCE
            }})
            .then(({data}) => {
              if(data) {
                appDispatch({
                  type: 'setLatestLesson',
                  lesson: {
                    lesson,
                    unit
                  }
                })
                appDispatch({
                  type: 'setLessonStatus',
                  lessonKey: lesson.slug,
                  unitKey: unit.key,
                  status: 'STARTED'
                })
              }
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              // Navigate to lesson
              setIsLoading(false)
              history.push(`/courses/${appState.course.slug}/${unit.key}/${lesson.slug}`)
            })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const purchaseCourse = (e) => {
    e.preventDefault()
    appDispatch({
      type: 'openStripeModal',
    })
  }

  return (
    <>
      {displayButton()}
      {appState.isStripeModalOpen && <StripeModal title="Purchase Course"/>}
    </>
  )
}

const ErrorText = styled.p`
  font-size: 0.7rem;
  color: var(--primary);
  margin-bottom: 0;
  margin-top: auto;
`

const CourseButtonStyle = styled.div`
  margin-bottom: 0;
  margin-top: auto;
`